import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCompanyData(companyId?: number, enabled = true) {
    const { data: companyData } = useQuery({
        queryKey: ['company-data', companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.companies.get', companyId));
            return data;
        },
        placeholderData: [],
        enabled: !!companyId && enabled,
        gcTime: 0,
    });

    return {
        companyData,
    };
}
